import React from "react";
import { Link } from "react-router-dom";
import { FaYoutube, FaFacebook } from "react-icons/fa";
import { microwe_dark_logo_img } from "../Constants/Data";

function Footer() {
  const handleClick = () => {
    window.scrollTo({
      top: 0,
    });
  };

  return (
    <div className="flex flex-col">

      {/* ================= TOP SECTION ================= */}
      <div className="md:py-[16px] pt-[24px] pb-[24px] md:bg-white bg-[#F5F5F5]">
        <div className="md:px-[24px] px-[16px]">
          <div className="container mx-auto">

            <div className="w-full flex md:flex-row flex-col items-center md:justify-between gap-[32px] text-[#231F20] text-center md:text-left">

              {/* Navigation Links */}
              <div className="flex md:flex-row flex-col md:gap-[28px] gap-[20px] font-Rubik font-medium md:text-[18px] text-[20px]">

                <div className="flex md:gap-[28px] gap-[48px] justify-center md:justify-start">
                  <Link to="/aboutus" onClick={handleClick}>
                    <h4 className="hover:text-red-600 transition duration-300">
                      ABOUT US
                    </h4>
                  </Link>

                  <Link to="/contactus" onClick={handleClick}>
                    <h4 className="hover:text-red-600 transition duration-300">
                      CONTACT US
                    </h4>
                  </Link>
                </div>

                <div className="flex justify-center md:justify-start">
                  <Link to="/matchscoreviewall" onClick={handleClick}>
                    <h4 className="hover:text-red-600 transition duration-300">
                      CRICKET
                    </h4>
                  </Link>
                </div>

              </div>

              {/* Social Icons */}
              <div className="flex items-center gap-[22px]">
                <a
                  href="https://www.youtube.com/@sjcjaffna2023"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaYoutube className="text-[30px] hover:text-red-600 transition duration-300" />
                </a>

                <a
                  href="https://www.facebook.com/stjohnscollege.jaffna"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaFacebook className="text-[25px] hover:text-blue-600 transition duration-300" />
                </a>
              </div>

            </div>
          </div>
        </div>
      </div>

      {/* ================= BOTTOM SECTION ================= */}
      <div className="bg-[#231F20] text-white">
        <div className="md:px-[24px] px-[16px]">
          <div className="container mx-auto">

            <div className="h-auto md:h-[60px] flex flex-col md:flex-row items-center justify-between py-4 md:py-0 gap-4 font-Rubik">

              {/* Left Side */}
              <div className="flex items-center gap-3">
                <h3 className="text-[14px] font-medium">
                  Designed by
                </h3>
                <a href="https://microwe.net" target="_blank" rel="noopener noreferrer">
                    <div className="flex items-center gap-3 bg-white px-4 py-2 rounded-full shadow-sm hover:shadow-md transition duration-300">
                      <img
                        src={microwe_dark_logo_img}
                        alt="Microwe"
                        className="h-4 w-auto object-contain opacity-80 hover:opacity-100 transition duration-300"
                      />
                    </div>
                </a>
              </div>

              {/* Right Side */}
              <h3 className="text-[14px] font-small text-center md:text-right">
                All rights reserved to St.Johns College Jaffna © {new Date().getFullYear()}
              </h3>

            </div>
          </div>
        </div>
      </div>

    </div>
  );
}

export default Footer;